export const PINK_ANGLE_COLORS = [0xFC99C4, 0xF94F6F];
export const BLUE_ANGLE_COLORS = [0x21D4FE, 0x0195B8];
export const CENTER_OF_CIRCLE = { x: 600, y: 310 };
export const CIRCLE_RADIUS = 200;
export const INITIAL_RADIANS = [-Math.PI / 1.35, -Math.PI / 4, Math.PI / 4.8, Math.PI / 1.4];
export const ARC_COLOR_ARR = [BLUE_ANGLE_COLORS[1], 0x000000, PINK_ANGLE_COLORS[1], 0x000000];
export const ANGLE_NAME_FOR_ANIM = "x";
export const SLIDERS_COORD = [{ x: 70, y: 800 }, { x: 440, y: 800 }];
export const SLIDERS_COORD_OFFSET_VERTICAL = [{ x: -260, y: 400 }, { x: 60, y: 400 }];
export const INFO_SLIDER_COORD = { x: 1180, y: 200 };
export const CAT_ASSET = "/circle-theorem-4/cat.png";
export const INFO_SLIDER_ASSETS_SLUG = "circle-theorem-4";